import { type IRemoveWagerUseCase, type IWagerClientService } from '../../../domain/entry.js';

/**
 * Use case for removing a wager.
 *
 * @param wagerClientService Wager client service dependency
 * @returns Use case executor for removing wagers
 */
export function removeWagerUseCase(wagerClientService: IWagerClientService): IRemoveWagerUseCase {
  return {
    execute: async ({
      wagerId,
      product,
      price,
      isMarketplace,
      showDialog,
      callbackOnDone,
      trackTransaction,
      icon,
    }): ReturnType<IRemoveWagerUseCase['execute']> => {
      await wagerClientService.removeWagerAsync({
        wagerId,
        product,
        price,
        isMarketplace,
        showDialog,
        callbackOnDone,
        trackTransaction,
        icon,
      });
    },
  };
}
